import { render, staticRenderFns } from "./ImportContractTickets.vue?vue&type=template&id=08c8214d&"
import script from "./ImportContractTickets.vue?vue&type=script&lang=js&"
export * from "./ImportContractTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports